import Image from "next/image";
import Quote from "@/components/Quote";

export const goodInsideContent = (
  <>
    <div className="prose dark:prose-invert max-w-none">
      <h3>What We Did</h3>
      <p>
        Campaign landing pages, brand standards, page design for product
        integrations, and paid campaign optimization
      </p>

      <h3>About the Client</h3>
      <p>
        Good Inside is Dr. Becky Kennedy&rsquo;s parenting platform: workshops,
        resources, and guidance for families navigating tough moments with more
        connection and less shame.
      </p>

      <h3>The Challenge</h3>
      <p>
        As Good Inside scaled, their in-house web team needed a partner who
        could move fast on campaign pages without sacrificing craft. New product
        launches, integrations, and paid campaigns all needed pages that felt
        unmistakably Good Inside and converted.
      </p>
      <p>
        Parents arrive through ads, workshops, and word of mouth. The site has
        to feel warm, clear, and trustworthy from the first scroll.
      </p>

      <h3>Campaign Pages That Convert</h3>
      <p>
        Township has worked alongside the Good Inside team to refine paid
        campaigns and landing pages to boost subscribers. The work is
        iterative: ship a page, learn from performance, tighten the next one.
      </p>
      <p>
        We helped update brand standards so new pages stay cohesive as the
        product line grows, and designed interfaces for new integrations as
        they rolled out.
      </p>

      <Image
        src="/assets/work/good-inside-2.png"
        alt="Good Inside campaign landing pages, gifting flow, and brand design system"
        width={2400}
        height={1350}
        className="my-8 h-auto w-full"
      />

      <h3>Children&rsquo;s Book Launch</h3>
      <p>
        A recent highlight was Dr. Becky&rsquo;s debut children&rsquo;s book,
        <em> That&rsquo;s My Truck!</em> Township partnered with her team to
        design and build a dedicated launch page with a book hero, preorder CTA,
        featured press logos, and illustration details that carry the same
        emotional tone as the story itself.
      </p>
      <p>
        The page went live ahead of preorder. Dr. Becky shared it with her
        audience on Instagram the same day.
      </p>

      <Image
        src="/assets/work/gi-kids.png"
        alt="Good Inside children's book launch landing page for That's My Truck!"
        width={1600}
        height={900}
        className="my-8 h-auto w-full"
      />

      <Quote
        text="As you may know, I recently announced that I&rsquo;ve written my first children&rsquo;s book (!) My incredible team partnered with Township to create - dare I say - the most beautiful web page... and it&rsquo;s now live on our site. Yes, I might be a little biased... but see for yourself!"
        author="Dr. Becky Kennedy"
        role="Founder, Good Inside"
        type="client"
        image={{
          src: "/assets/logos/becky.jpg",
          alt: "Dr. Becky Kennedy",
        }}
      />
    </div>
  </>
);
